// Claim-code normalization (#135).
//
// A camera's Claim code is generated as `XXXX-XXXX` — 8 chars from an uppercase
// alphabet with a hyphen after the 4th (cloud/src/lib/crypto.ts `generateUserCode`).
// The Worker only `trim().toUpperCase()`s what the Owner submits (it does NOT
// re-insert the hyphen or strip spaces), so a pasted code that's lowercase, missing
// the hyphen, or space-separated 404s as "invalid" even when the characters are right.
//
// `normalizeClaimCode` rebuilds the canonical `XXXX-XXXX` form from any reasonable
// input, so it matches the stored code. It doubles as the display mask — typing into
// the field formats live — so the field always reads exactly like the camera's QR.

/** Rebuild the canonical `XXXX-XXXX` Claim code: uppercase, alphanumerics only, regrouped. */
export function normalizeClaimCode(raw: string): string {
  const c = raw
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 8);
  return c.length > 4 ? `${c.slice(0, 4)}-${c.slice(4)}` : c;
}
